import { InjectionToken } from "@angular/core";
/**
 * Injector Token for {@link TranslationHelper}
 */
export const TRANSLATION_HELPER = new InjectionToken("TranslationHelper");
